// extracted by mini-css-extract-plugin
module.exports = {"yellowColour":"#F3C627","extraDarkColour":"#373737","backgroundColour":"#171C1F"};